// dependencies imports ⇒
import React, { useState, useEffect, useContext } from "react";
import FormControl from "@material-ui/core/FormControl";
import FilledInput from "@material-ui/core/FilledInput";
import Drawer from "@material-ui/core/Drawer";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import Popover from "react-popover";
// assets and scss imports ⇒
import "./Staff.scss";
import CloseIcon from "../../assets/close_icon.png";
import info_icon from "../../assets/dashboard/info_icon.svg";
// project file imports(UI components) ⇒
import DeleteModal from "./DeleteModal";
import StaffWebView from "./StaffWebView";
import StaffMobView from "./StaffMobView";
import Loader from "../UI Component/Loader/Loader";
import FooterPagination from "../common/FooterPagination";
import CustomToggleButton from "../common/Buttons/CustomToggleButton";
import StaffAlertMessagePopup from "../common/StaffAlertMessgePopup";
// const file imports(helper methods, etc) ⇒
import { useTimer } from "../../Hooks/useTimer";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import DoctorContext from "../ClinicComponents/ClinicWrapper/DoctorContext";
import { USER_ROLE, USER_TYPE } from "../../Util/constants";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";
import { MANY_ATTEMPT_ERROR_MESSAGE } from "../DoctorSignInContainer/constant";
import {
  ADD_CLINIC_STAFF,
  ADD_DOCTOR_STAFF,
  DELETE_CLINIC_STAFF,
  DELETE_DOCTOR_STAFF,
  GET_CLINIC_STAFF_INFO,
  GET_DOCTOR_STAFF_LIST,
  UPDATE_CLINIC_STAFF_INFO,
  UPDATE_DOCTOR_STAFF_INFO,
  VERIFY_CLINIC_STAFF,
  VERIFY_DOCTOR_STAFF,
} from "./constants/apiConstants";
import {
  DEFAULT_STAFF_ALERT_MESSAGE,
  STAFF_PERMISSION_LIST,
  STAFF_PERMISSION_SET,
} from "./constants/constants";
import { Spinner } from "react-bootstrap";

function Staff() {
  // const declarations ⇒
  const [activity, setActivity] = useState("add"); // add: addition of new staff (default)     edit: editing an existing staff
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [staffName, setStaffName] = useState("");
  const [staffId, setStaffId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showSubmit, setShowSubmit] = useState(true);
  const [askOtp, setAskOtp] = useState(false);
  const [otpInput, setOtpInput] = useState("");
  const [otpApproved, setOtpApproved] = useState(true);
  const [otpError, setOtpError] = useState({
    status: false,
    message: "",
  });
  const [resendAllowed, setResendAllowed] = useState(false);
  const [key, setKey] = useState(0);
  const [submitAllowed, setSubmitAllowed] = useState({
    name: staffName.length > 0,
    phone: phoneNumber.length == 10,
  });
  const [staffList, setStaffList] = useState([]);
  const [getstaffList, setGetStaffList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const doctor_context = useContext(DoctorContext);
  const [doctorRole, setDoctorRole] = useState("");
  const [pageLoader, setPageLoader] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [isManyAttempts, setIsManyAttempts] = useState(false);
  const [staffRoleAccess, setStaffRoleAccess] = useState([
    ...STAFF_PERMISSION_LIST,
  ]);
  const [alertMessage, setAlertMessage] = useState({
    show: false,
    title: "",
    content: "",
    type: "",
  });
  const [sectionLoader, setSectionLoader] = useState(false);

  const { time, start, reset } = useTimer({
    initialTime: 60,
    endTime: 0,
    timerType: "DECREMENTAL",
    autostart: false,
    onTimeOver: () => {
      setResendAllowed(true);
    },
  });

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);

  // life cycle methods ⇒
  useEffect(() => {
    if (
      localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE) !== null &&
      localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE) !== undefined
    ) {
      setDoctorRole(localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE));
    } else {
      setDoctorRole("");
    }
    getStaffListApiCall();
  }, [key, doctor_context?.clinic_id]);

  // API Calls ⇒

  const getStaffListApiCall = (hideLoader) => {
    if (!hideLoader) {
      setPageLoader(true);
    }
    let apiUrl = doctor_context?.clinic_id
      ? GET_CLINIC_STAFF_INFO
      : GET_DOCTOR_STAFF_LIST;
    let payload = {
      doctor_id: userId,
      ...(doctor_context?.clinic_id && {
        clinic_id: doctor_context?.clinic_id,
      }),
    };
    const staffListResponse = c2cPostApiHandler(apiUrl, payload);
    staffListResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setGetStaffList(res.data.data);
          setCurrentPage(1);
          getPaginateData(1, res.data.data);
          setPageLoader(false);
        } else {
          setGetStaffList([]);
          setStaffList([]);
          setPageLoader(false);
        }
      } else {
        setGetStaffList([]);
        setStaffList([]);
        setPageLoader(false);
      }
    });
  };

  const getStaffInfoApiCall = (staffId, activityType) => {
    let apiUrl = doctor_context?.clinic_id
      ? GET_CLINIC_STAFF_INFO
      : GET_DOCTOR_STAFF_LIST;
    let payload = {
      doctor_id: userId,
      ...(doctor_context?.clinic_id && {
        clinic_id: doctor_context?.clinic_id,
      }),
      staff_id: staffId,
    };
    const staffInfoResponse = c2cPostApiHandler(apiUrl, payload);
    staffInfoResponse.then(([res, error]) => {
      if (!error) {
        if (res.data.statusCode === 200) {
          let name;
          if (
            res.data.data[0].middle_name === " " ||
            res.data.data[0].middle_name === ""
          ) {
            name = `${res.data.data[0].first_name} ${res.data.data[0].last_name}`;
          } else {
            name = `${
              res.data.data[0].first_name
            } ${res.data.data[0].middle_name.trim()} ${
              res.data.data[0].last_name
            }`;
          }
          setStaffName(name.trim());
          setPhoneNumber(res.data.data[0].phone_no.substring(3));
          setStaffId(staffId);

          if (
            userType === USER_TYPE?.DOCTOR &&
            clinicId &&
            doctorRole === USER_ROLE?.DOCTOR_ADMIN &&
            activityType === "edit"
          ) {
            let tempPermissionList = [...staffRoleAccess];
            if (
              res?.data?.permission_set &&
              Object.keys(res?.data?.permission_set)?.length > 0
            ) {
              tempPermissionList.forEach((permission) => {
                permission.isEnabled =
                  res?.data?.permission_set[permission.key][0] === 1 &&
                  res?.data?.permission_set[permission.key][1] === 1;
              });
              setStaffRoleAccess(tempPermissionList);
            } else {
              tempPermissionList.forEach(
                (permission) => (permission.isEnabled = true)
              );
              setStaffRoleAccess(tempPermissionList);
            }
          }
          setSectionLoader(false);
        } else {
          setSectionLoader(false);
          setActivity("add");
          setDrawerOpen(false);
          callAlertMessage({
            show: true,
            type: "error",
            title: res?.data?.message,
          });
        }
      } else {
        setSectionLoader(false);
        setActivity("add");
        setDrawerOpen(false);
        callAlertMessage({
          show: true,
          type: "error",
          title: "Something went wrong! Try Again",
        });
      }
    });
  };

  const updateStaffDetailsApiCall = () => {
    let staffNameTrimed = staffName.trim();
    let firstIndexOfName = staffNameTrimed.indexOf(" ");
    let lastIndexOfName = staffNameTrimed.lastIndexOf(" ");
    let permissionList = {};

    if (checkToShowPermissionButton()) {
      permissionList = {
        usertransactionreport:
          STAFF_PERMISSION_SET.USER_TRANSACTION_REPORT_ENABLED,
      };
      staffRoleAccess.forEach((data) => {
        if (data?.key === "clinictransactionreport") {
          permissionList[data?.key] = data?.isEnabled
            ? STAFF_PERMISSION_SET?.CLINIC_TRANSACTION_REPORT_ENABLED
            : STAFF_PERMISSION_SET?.CLINIC_TRANSACTION_REPORT_DISABLED;
        } else if (data?.key === "appointmentreport") {
          permissionList[data?.key] = data?.isEnabled
            ? STAFF_PERMISSION_SET?.APPOINTMENT_REPORT_ENABLED
            : STAFF_PERMISSION_SET?.APPOINTMENT_REPORT_DISABLED;
        }
      });
    }
    let nameObj = {};
    if (firstIndexOfName === -1 && lastIndexOfName === -1) {
      nameObj = {
        first_name: staffNameTrimed,
        middle_name: "",
        last_name: "",
      };
    } else {
      nameObj = {
        first_name: staffNameTrimed.substring(0, firstIndexOfName),
        middle_name: staffNameTrimed.substring(
          firstIndexOfName + 1,
          lastIndexOfName
        ),
        last_name: staffNameTrimed.substring(lastIndexOfName + 1),
      };
    }
    let apiUrl = doctor_context?.clinic_id
      ? UPDATE_CLINIC_STAFF_INFO
      : UPDATE_DOCTOR_STAFF_INFO;
    let payload = {
      doctor_id: userId,
      ...(doctor_context?.clinic_id && {
        clinic_id: doctor_context?.clinic_id,
      }),
      staff_id: staffId,
      ...nameObj,
      ...(checkToShowPermissionButton() && { permission_set: permissionList }),
    };

    const updatedStaffResponse = c2cPostApiHandler(apiUrl, payload);
    updatedStaffResponse.then(([res, error]) => {
      if (!error) {
        if (res.data.statusCode === 200) {
          setStaffName("");
          setPhoneNumber("");
          setDrawerOpen(false);
          setKey(key + 1);
          callAlertMessage({
            show: true,
            type: "success",
            title: res?.data?.message,
          });
        } else if (res?.data?.statusCode === 500) {
          callAlertMessage({
            show: true,
            type: "error",
            title: "Staff Record Already Exists",
            content: {
              __html: `You will not be able to edit staff name and mobile number as this staff with <b>${res?.data?.staff_phone_no}</b> is associated with other doctors with the name of <b>${res?.data?.staff_name}</b>. Please use the same name.`,
            },
          });
        } else {
          callAlertMessage({
            show: true,
            type: "error",
            title: res?.data?.message,
          });
        }
      } else {
        callAlertMessage({
          show: true,
          type: "error",
          title:
            "Saving setting fails due to system errors or connectivity issues",
        });
      }
    });
  };

  const deleteStaffApiCall = () => {
    let payload = {
      doctor_id: userId,
      ...(doctor_context?.clinic_id && {
        clinic_id: doctor_context?.clinic_id,
      }),
      staff_id: staffId,
    };
    let apiUrl = doctor_context?.clinic_id
      ? DELETE_CLINIC_STAFF
      : DELETE_DOCTOR_STAFF;
    const deleteStaffResponse = c2cPostApiHandler(apiUrl, payload);
    deleteStaffResponse.then(([res, error]) => {
      if (!error) {
        if (res.data.statusCode === 200) {
          setDeleteModal(false);
          setKey(key + 1);
        } else {
          callAlertMessage({
            show: true,
            type: "error",
            title: res?.data?.message,
          });
        }
      } else {
        callAlertMessage({
          show: true,
          type: "error",
          title: "Something went wrong! Try Again",
        });
      }
    });
  };

  const addStaffApiCall = (payload) => {
    let apiUrl = doctor_context?.clinic_id
      ? ADD_CLINIC_STAFF
      : ADD_DOCTOR_STAFF;
    const addStaffResponse = c2cPostApiHandler(apiUrl, payload);
    addStaffResponse.then(([res, error]) => {
      if (!error) {
        reset();
        if (res.data.statusCode === 200) {
          setAskOtp(true);
          start();
          setShowSubmit(false);
          setIsManyAttempts(false);
        } else if (res.data.statusCode === 409) {
          callAlertMessage({
            show: true,
            type: "error",
            title: res.data.message,
          });
        } else if (res.data.statusCode === 500) {
          callAlertMessage({
            show: true,
            type: "error",
            title: "Staff Record Already Exists",
            content: {
              __html: `This staff with <b>${res?.data?.staff_phone_no}</b> is associated with other doctors with the name of <b>${res?.data?.staff_name}</b>. Please use the same name.`,
            },
          });
        } else if (res.data.statusCode === 520) {
          setIsManyAttempts(true);
        } else {
          callAlertMessage({
            show: true,
            type: "error",
            title: res.data.message,
          });
        }
      } else {
        callAlertMessage({
          show: true,
          type: "error",
          title: "Something went wrong! Try Again",
        });
      }
    });
  };

  const verifyStaffApiCall = (payload) => {
    let apiUrl = doctor_context?.clinic_id
      ? VERIFY_CLINIC_STAFF
      : VERIFY_DOCTOR_STAFF;
    const verifyStaffResponse = c2cPostApiHandler(apiUrl, payload);
    verifyStaffResponse.then(([res, error]) => {
      if (!error) {
        if (res.data.statusCode === 200) {
          setStaffId(res?.data?.staff_id);
          if (
            userType === USER_TYPE?.DOCTOR &&
            clinicId &&
            doctorRole === USER_ROLE?.DOCTOR_ADMIN
          ) {
            setActivity("edit");
          } else {
            setDrawerOpen(false);
          }
          callAlertMessage({
            show: true,
            type: "success",
            title: "Staff Added Successfully",
            content: {
              __html: `New staff member "${staffName}" added to your virtual clinic`,
            },
          });
          getStaffListApiCall(true);
          setIsManyAttempts(false);
        }
        if (res.data.statusCode === 520) {
          setIsManyAttempts(true);
        } else if (res.data.statusCode === 400) {
          setOtpError({
            ...otpError,
            status: true,
            message: res.data.message,
          });
        } else {
          callAlertMessage({
            show: true,
            type: "error",
            title: res.data.message,
          });
        }
      } else {
        callAlertMessage({
          show: true,
          type: "error",
          title: "Something went wrong! Try Again",
        });
      }
    });
  };

  // Helper methods ⇒
  const checkToShowPermissionButton = () => {
    return (
      userType === USER_TYPE?.DOCTOR &&
      clinicId &&
      doctorRole === USER_ROLE?.DOCTOR_ADMIN &&
      activity === "edit"
    );
  };

  // Actions ⇒
  const handlePopoverOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  function handleAdd() {
    setStaffName("");
    setPhoneNumber("");
    setDrawerOpen(true);
    setSubmitAllowed({ ...submitAllowed, name: false, phone: false });
    setActivity("add");
    setAskOtp(false);
    setShowSubmit(true);
    setOtpError({ ...otpError, status: false });
    setOtpInput("");
    setOtpApproved(true);
    setResendAllowed(false);
    reset();
  }

  function handleName(name) {
    if (name == "") {
      setStaffName(name);
      setSubmitAllowed({ ...submitAllowed, name: false });
      return;
    }
    setStaffName(name);
    setSubmitAllowed({ ...submitAllowed, name: true });
  }

  function handlePhoneNumber(num) {
    if (num == "") setPhoneNumber(num);
    if (num.length < 10) setSubmitAllowed({ ...submitAllowed, phone: false });
    if (num.length == 10) setSubmitAllowed({ ...submitAllowed, phone: true });
    if (num.length > 10) return;
    const indianPattern = RegExp(/^[1-9][0-9]*$/);
    if (indianPattern.test(num)) {
      setPhoneNumber(num);
    }
  }

  const handleSubmit = (e, mode) => {
    e.preventDefault();
    setResendAllowed(false);

    if (mode === "resend") {
      setOtpInput("");
      setOtpError({ ...otpError, status: false, message: "" });
      setOtpApproved(true);
    }

    let staffNameTrimed = staffName.trim();

    let firstIndexOfName = staffNameTrimed.indexOf(" ");
    let lastIndexOfName = staffNameTrimed.lastIndexOf(" ");

    let nameObj = {};
    if (firstIndexOfName === -1 && lastIndexOfName === -1) {
      nameObj = {
        staff_first_name: staffNameTrimed,
        staff_middle_name: "",
        staff_last_name: "",
      };
    } else {
      nameObj = {
        staff_first_name: staffNameTrimed.substring(0, firstIndexOfName),
        staff_middle_name: staffNameTrimed.substring(
          firstIndexOfName + 1,
          lastIndexOfName
        ),
        staff_last_name: staffNameTrimed.substring(lastIndexOfName + 1),
      };
    }
    let payload = {
      channel_id: "staff-login",
      staff_phone_no: `+91${phoneNumber}`,
      login_type: "OTP",
      add_new: mode === "resend" ? false : true,
      user_type: localStorage.getItem("user_type"),
      ...nameObj,
      doctor_id: userId,
    };
    if (doctor_context?.clinic_id) {
      payload["clinic_id"] = doctor_context?.clinic_id;
    }

    addStaffApiCall(payload);
  };

  const getOTPAdornment = () => {
    if (otpError.status) return <ErrorIcon style={{ color: "#e84444" }} />;
    if (!otpApproved) return <CheckCircleIcon style={{ color: "#10A74A" }} />;
    return null;
  };

  const handleOtpInput = (input) => {
    if (input.length > 6) return;
    if (input.length !== 6) {
      setOtpApproved(true);
      setOtpError({ ...otpError, status: false });
      setOtpInput(input);
      return;
    } else {
      setOtpInput(input);
      setOtpApproved(false);
    }
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    setOtpError({ ...otpError, status: false });
    if (otpInput.length !== 6) {
      setOtpError({
        ...otpError,
        status: false,
        message: "OTP must be exactly 6 characters",
      });
      setOtpApproved(true);
      return;
    } else {
      setOtpApproved(false);
      let obj = {
        "authorizer-principal-id": {
          user_type: "1",
          user_id: userId,
        },
        channel_id: "staff-login",
        staff_phone_no: `+91${phoneNumber}`,
        OTP: otpInput,
        user_type: "doctor",
      };
      if (
        doctor_context?.clinic_id !== "" &&
        doctor_context?.clinic_id !== undefined
      ) {
        obj["clinic_id"] = doctor_context?.clinic_id;
      }
      verifyStaffApiCall(obj);
    }
  };

  const handleEdit = (staffId) => {
    setSectionLoader(true);
    setActivity("edit");
    setDrawerOpen(true);
    setSubmitAllowed({ ...submitAllowed, name: false, phone: false });
    getStaffInfoApiCall(staffId, "edit");
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    updateStaffDetailsApiCall();
  };

  const handleDelete = (staffId, firstname, lastname) => {
    let name = firstname + " " + lastname;
    setStaffName(name);
    setStaffId(staffId);
    setDeleteModal(true);
  };

  const yesClickHandler = (e) => {
    e.preventDefault();
    deleteStaffApiCall();
    setTimeout(() => {
      document.getElementsByTagName("body")[0].removeAttribute("style");
    }, 300);
  };

  const noClickHandler = (e) => {
    e.preventDefault();
    setDeleteModal(false);
    setTimeout(() => {
      document.getElementsByTagName("body")[0].removeAttribute("style");
    }, 300);
  };

  const handleChange = (index) => {
    let tempAccessRole = [...staffRoleAccess];
    tempAccessRole[index].isEnabled = !tempAccessRole[index]?.isEnabled;
    setStaffRoleAccess([...tempAccessRole]);
  };

  const getPaginateData = (currentPage, data) => {
    const startIndex = currentPage * 10 - 10;
    const endIndex = startIndex + 10;
    return setStaffList(
      data
        ? data?.slice(startIndex, endIndex)
        : getstaffList?.slice(startIndex, endIndex)
    );
  };

  const handleCloseAlertMsg = () => {
    setAlertMessage({ ...DEFAULT_STAFF_ALERT_MESSAGE });
  };

  const callAlertMessage = (messageObj) => {
    setAlertMessage({ ...messageObj });
    setTimeout(() => {
      handleCloseAlertMsg();
    }, 4000);
  };

  // UI

  const displayHoverContent = (popoverContent) => {
    return (
      <div className="permission-popover-content">
        {popoverContent.map((item, index) => (
          <div key={index}>
            <p className="permission-popover-header">{item?.heading}</p>
            <ul>
              {item?.content?.map((data, index) => (
                <li key={index}>{data?.text}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    );
  };

  const getStaffPermissionUI = () => {
    return (
      <div>
        {staffRoleAccess.map((permissionContent, index) => (
          <div className="permission-role-access-container" key={index}>
            <div className="permission-content" key={index}>
              <p className="permission-option-title">
                {permissionContent?.title}
                {permissionContent?.infoContent && (
                  <Popover
                    isOpen={isOpen}
                    preferPlace={`below`}
                    place={null}
                    anchorEl={anchorEl}
                    body={displayHoverContent(permissionContent?.infoContent)}
                  >
                    <img
                      src={info_icon}
                      alt=""
                      style={{ cursor: "pointer", marginLeft: "6px" }}
                      onMouseOver={handlePopoverOpen}
                      onMouseOut={handlePopoverClose}
                    />
                  </Popover>
                )}
              </p>
            </div>
            <div>
              <CustomToggleButton
                checked={permissionContent?.isEnabled}
                key={permissionContent?.key}
                handleChange={() => {
                  handleChange(index);
                }}
              />
            </div>
          </div>
        ))}
      </div>
    );
  };
  return (
    <>
      {pageLoader ? (
        <Loader />
      ) : (
        <>
          {alertMessage?.show && (
            <StaffAlertMessagePopup
              alertMsg={alertMessage}
              handleClose={handleCloseAlertMsg}
            />
          )}

          <DeleteModal
            deleteModal={deleteModal}
            staffName={staffName}
            yesClickHandler={yesClickHandler}
            noClickHandler={noClickHandler}
          />

          <div className="staff-web-view mt-0 mx-0 pt-3 pr-3 pl-3 pb-0">
            <div
              className={`${doctorRole == "consultant" ? "disable_btn" : ""}`}
            >
              <div
                className={`${
                  doctorRole == "consultant" ? "disable_pointer" : ""
                }`}
              >
                <StaffWebView
                  staffList={staffList}
                  setDrawerOpen={handleAdd}
                  staffEdit={handleEdit}
                  staffDelete={handleDelete}
                  currentPage={currentPage}
                  getstaffList={getstaffList}
                  doctorRole={doctorRole}
                />
              </div>
            </div>
          </div>
          <div className="staff-mob-view mt-0 mx-0 p-3">
            <div
              className={`${doctorRole == "consultant" ? "disable_btn" : ""}`}
            >
              <div
                className={`${
                  doctorRole == "consultant" ? "disable_pointer" : ""
                }`}
              >
                <StaffMobView
                  staffList={staffList}
                  setDrawerOpen={handleAdd}
                  staffEdit={handleEdit}
                  staffDelete={handleDelete}
                  currentPage={currentPage}
                  getstaffList={getstaffList}
                  doctorRole={doctorRole}
                />
              </div>
            </div>
          </div>
          {getstaffList?.length > 0 ? (
            <div className="staff-footer-pagination">
              <FooterPagination
                currentPage={currentPage}
                totalCount={getstaffList?.length}
                pageSize={10}
                onPageChange={(page) => {
                  setCurrentPage(page);
                  getPaginateData(page);
                }}
              />
            </div>
          ) : null}
          <Drawer
            anchor="right"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
          >
            <div className="p-4">
              <div className="d-flex justify-content-between align-items-center">
                <div className="drawer-staff-details">Staff Details</div>
                <div>
                  <img
                    src={CloseIcon}
                    onClick={() => {
                      setDrawerOpen(false);
                      setIsManyAttempts(false);
                    }}
                    style={{ cursor: "pointer" }}
                    alt=""
                  />
                </div>
              </div>
              <div className="d-flex staff-details-heading py-3">
                Provide staff member name along with his phone number to enable
                support staff
              </div>
              <div>
                {sectionLoader ? (
                  <div className="my-3 text-center">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <form>
                    <FormControl
                      hiddenLabel="true"
                      size="small"
                      margin="dense"
                      fullWidth="true"
                    >
                      <FilledInput
                        style={{
                          backgroundColor: "#F5F6F7",
                        }}
                        className="shadow-sm"
                        placeholder="Staff Name"
                        id="name-input"
                        aria-describedby="my-helper-text"
                        aria-label="name-input"
                        autoFocus={true}
                        disableUnderline="true"
                        inputProps={{
                          inputMode: "text",
                        }}
                        onChange={(e) => handleName(e.target.value)}
                        value={staffName}
                        required
                      />

                      <FilledInput
                        style={{
                          backgroundColor: "#F5F6F7",
                        }}
                        className="shadow-sm mt-4"
                        placeholder="Enter Phone Number"
                        id="phone-input"
                        aria-describedby="my-helper-text"
                        aria-label="phone-input"
                        startAdornment={<Plus91 />}
                        disableUnderline="true"
                        inputProps={{
                          inputMode: "numeric",
                        }}
                        onChange={(e) => handlePhoneNumber(e.target.value)}
                        value={phoneNumber}
                        required
                        readOnly={activity === "edit"}
                      />
                    </FormControl>
                    {isManyAttempts && (
                      <div className="staff-error-content">
                        {MANY_ATTEMPT_ERROR_MESSAGE}
                      </div>
                    )}

                    {checkToShowPermissionButton() && getStaffPermissionUI()}
                    {showSubmit && activity === "add" ? (
                      <button
                        className="btn primary-cta-button rounded-pill mt-4 align-self-center py-2 px-4"
                        disabled={!submitAllowed.name || !submitAllowed.phone}
                        onClick={(e) => handleSubmit(e, "submit")}
                      >
                        Submit
                      </button>
                    ) : (
                      ""
                    )}
                    {activity === "edit" ? (
                      <button
                        className="btn primary-cta-button rounded-pill mt-4 align-self-center py-2 px-4"
                        disabled={
                          !checkToShowPermissionButton() && !submitAllowed.name
                        }
                        onClick={(e) => handleUpdate(e)}
                      >
                        {checkToShowPermissionButton()
                          ? "Save and Update Permissions"
                          : "Update"}
                      </button>
                    ) : (
                      ""
                    )}
                  </form>
                )}
              </div>
              {askOtp && activity === "add" ? (
                <>
                  <div className="validate-staff mt-4">
                    Validate Staff Details
                  </div>
                  <div className="d-flex staff-details-heading py-2">
                    Please enter the OTP sent to the number above
                  </div>
                  <div>
                    <form onSubmit={(e) => handleOtpSubmit(e)}>
                      <FormControl
                        hiddenLabel="true"
                        size="small"
                        margin="dense"
                        fullWidth="true"
                      >
                        <FilledInput
                          id="OTP-input"
                          aria-describedby="my-helper-text"
                          required
                          aria-required
                          placeholder="Enter OTP"
                          aria-label="otp-input"
                          autoFocus={true}
                          inputProps={{
                            autoComplete: "off",
                            inputMode: "numeric",
                          }}
                          disableUnderline="true"
                          value={otpInput}
                          endAdornment={getOTPAdornment()}
                          onChange={(e) => handleOtpInput(e.target.value)}
                        />
                      </FormControl>
                      <div className="d-flex justify-content-between">
                        <div className="col-6 p-0">
                          {resendAllowed ? (
                            <div className="align-self-start text-muted">
                              OTP expired
                            </div>
                          ) : (
                            <div className="align-self-start text-muted">
                              {time} seconds left to expire
                            </div>
                          )}
                        </div>
                        <div className="col-6 p-0 d-flex justify-content-end align-items-start">
                          <div
                            className={`cursor-pointer ${
                              !resendAllowed
                                ? "text-muted pointer-disabled"
                                : "textLink"
                            }`}
                            style={{ textAlign: "right" }}
                            onClick={(e) => handleSubmit(e, "resend")}
                          >
                            Resend OTP
                          </div>
                        </div>
                      </div>
                      <div className="text-danger mt-1">
                        {otpError.status ? otpError.message : ""}
                      </div>
                      <button
                        className="btn primary-cta-button rounded-pill mt-2 align-self-center py-2 px-4"
                        disabled={otpApproved}
                      >
                        Verify
                      </button>
                    </form>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </Drawer>
        </>
      )}
    </>
  );
}

const Plus91 = () => <div className="adornment-beautify">+91</div>;

export default Staff;
